import React from 'react';
import classNames from 'classnames';
import { ArticleHeader, Linklist, Section, Render } from '../../platformui';
import BlockTypeRenderer from '../../framework/base/blocktype-renderer';

const BlockProps = (BlockTypeName) => {
  if (BlockTypeName === 'ImageBlock')
    return {
      Modifiers: {
        'c-imageblock--no-margin': true,
        'c-section--no-margin': true,
      },
      UseZoom: false,
    };

  if (BlockTypeName === 'LinkCollectionBlock')
    return {
      Modifiers: { 'c-linklist--inline': true },
    };

  return null;
};

const BlockGrid = (props) => {
  const gridClassName = classNames({
    columns: true,
    'small-11': props.BlockTypeName !== 'TwoColumnBlock',
    'medium-9': props.BlockTypeName !== 'TwoColumnBlock',
    'small-centered': props.BlockTypeName !== 'TwoColumnBlock',
    'u-text-center': props.BlockTypeName === 'LinkCollectionBlock',
  });

  const blockModifierProps = BlockProps(props.BlockTypeName);
  return (
    <div className="row">
      <div className={gridClassName}>
        {props.BlockTypeName === 'LinkCollectionBlock' ? (
          <Linklist {...props} {...blockModifierProps} />
        ) : (
          <BlockTypeRenderer {...props} {...blockModifierProps} />
        )}
      </div>
    </div>
  );
};

const ErrorPage404 = (props) => {
  const introClasses = classNames({
    'medium-offset-2': true,
    'medium-8': true,
    'large-offset-0': true,
    'large-8': true,
    'large-centered': true,
    'u-text-center': true,
    columns: true,
  });

  return (
    <main id="content" className="main">
      {(props.Content.Heading || props.Content.Preamble) && (
        <Section Modifiers={{ 'c-section--no-margin': true }}>
          <div className="row">
            <div className={introClasses}>
              <ArticleHeader
                Heading={Render.Property(props.Content.Heading, 'Heading')}
                Preamble={null}
              />
              <div
                className="preamble preamble--narrow"
                dangerouslySetInnerHTML={{
                  __html: Render.Property(props.Content.Preamble, 'Preamble'),
                }}
              ></div>
            </div>
          </div>
        </Section>
      )}
      <Render.Block
        blocks={props.Content.MainContent}
        propertyName="MainContent"
        currentPageProps={props}
      >
        <BlockGrid />
      </Render.Block>
    </main>
  );
};

export default ErrorPage404;
